

import  resportDetail    from  '@/components/reports/resportDetail'
import  resportList      from  '@/components/reports/resportList'
import  clientCare       from  '@/components/reports/clientCare'
import  report4SalesAnalysis from '@/components/reports/report4SalesAnalysis'

export default  [

    {
        path: '/resportDetail',
        name: 'resportDetail',
        component: resportDetail,
        meta: {
          title: "销售分析表",
          keepAlive: false
        }
      },
      {
        path: '/resportList',
        name: 'resportList',
        component: resportList,
        meta: {
          title: "零售报表",
          keepAlive: false
        }
      },
      {
        path: '/clientCare',
        name: 'clientCare',
        component: clientCare,
        meta: {
          title: "客户关怀表",
          keepAlive: false
        }
      },
      {
        path: '/report4SalesAnalysis',
        name: 'report4SalesAnalysis',
        component: report4SalesAnalysis,
        meta: {
          title: "销售分析报表"
        }
      },
]



// WEBPACK FOOTER //
// ./src/router/report.js